import { createContext, useContext, useState } from 'react';
import BankSlipHistoryTable from '@/components/Financial/BankSlip/BankSlipHistory/BankSlipHistoryTable';
import { TabContentWrapper } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { useDebounce } from '@/hooks';
import {
  ListBillets,
  ListBilletsQuery,
} from '@/core/domain/financial/Boletos/Boletos.types';

import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import BankSlipFooter from '@/components/Financial/BankSlip/BankSlipFooter';
import { Divider } from 'antd';

type BankSlipContextProps = {
  selectedBankSlips: ListBillets[];
  setSelectedBankSlips: React.Dispatch<React.SetStateAction<ListBillets[]>>;
  queryParams: ListBilletsQuery;
};

const BankSlipContext = createContext({} as BankSlipContextProps);

export const useBankSlipFormContext = () => useContext(BankSlipContext);

export default function BankSlipPage({ route }: PageProps) {
  const [selectedBankSlips, setSelectedBankSlips] = useState<ListBillets[]>([]);

  const [queryParams, setQueryParams] = useState<ListBilletsQuery>({
    order: 'DESC',
    ...convertParams<ListBilletsQuery>({
      companyId: 'number',
      search: 'string',
    }),
  });

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  return (
    <BankSlipContext.Provider
      value={{
        selectedBankSlips,
        setSelectedBankSlips,
        queryParams,
      }}
    >
      <TabContentWrapper permissions={route.permissions} title={route.name}>
        <BankSlipHistoryTable
          selectedBankSlips={selectedBankSlips}
          setSelectedBankSlips={setSelectedBankSlips}
          setQueryParams={setQueryParams}
          queryParams={queryParams}
        />

        <Divider />

        <BankSlipFooter />
      </TabContentWrapper>
    </BankSlipContext.Provider>
  );
}
